import { render, staticRenderFns } from "./CRTab.vue?vue&type=template&id=d9cd6144&scoped=true"
import script from "./CRTab.vue?vue&type=script&lang=js"
export * from "./CRTab.vue?vue&type=script&lang=js"
import style0 from "./CRTab.vue?vue&type=style&index=0&id=d9cd6144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cd6144",
  null
  
)

export default component.exports